export const getHomeScroll = state =>
    state.globalData.homeTopScroll;
